import { z } from 'zod'

import { cap } from '../../../../State'
import { translations } from '../../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/
const numericRegex = /^\d*$/

const buildFieldSchema = (item) => {
  const required = !item.notRequired
  const limit = item.limitLength || 35
  let base
  switch (item.type) {
    case 'numeric':
      base = z.string().max(limit, `Massimo ${limit} caratteri`).regex(numericRegex, t.gfSoloNumeri)
      break
    case 'date':
      base = z.union([z.string().regex(dateRegex, t.gfFormatoData), z.literal('')])
      break
    case 'dropdown': {
      const values = (item.options || []).map((o) => o.value).filter((v) => v !== undefined)
      base = values.length ? z.union([z.enum(values), z.literal('')]) : z.string()
      break
    }
    default:
      base = z.string().max(limit, `Massimo ${limit} caratteri`)
  }

  if (!required) return base.optional().or(z.literal(''))
  return base.refine((v) => v !== undefined && v !== null && v !== '', t.gfCampoObbligatorio)
}

export const buildCampi1a10Schema = (items = []) =>
  z.object(Object.fromEntries(items.map((i) => [i.id, buildFieldSchema(i)])))

export const buildDefaultValues = (items = [], state) =>
  Object.fromEntries(
    items.map((i) => {
      const path = i.location.split('.')
      let cursor = state
      for (const k of path) cursor = cursor?.[k]
      return [i.id, cursor ?? '']
    })
  )
